import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCalendarFilled = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      d="M6.249 1.41a1.125 1.125 0 0 1 2.25 0v.876h6.75V1.41a1.125 1.125 0 1 1 2.25 0v.875h2.75a3 3 0 0 1 3 3v5h-22v-5a3 3 0 0 1 3-3h2z"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M1.249 12.286v9a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-9zm9 3h-4v4h4z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCalendarFilled);
export default Memo;
